import draftTypes from './draftTypes';

export default {
  [draftTypes.DRAFT_CAPITAL_INCREASE]: {
    production: '6577fe6af74be6e821dbe49f',
    development: '657448f84d850a40385ec354',
  },
};
